<div class="modal-header">
  <h4 md-dialog-title class="modal-title pull-left">{{ data.Header }}</h4>
</div>
<div class="modal-body">
  <mat-dialog-content>
    <div>
      <form [formGroup]="gspInputModalFg">
        <adp-input [resourceData]="data.Resource" class="fullWidth" formControlName="inputValue"></adp-input>
      </form>
    </div>
  </mat-dialog-content>
</div>
<div class="modal-footer">
  <mat-dialog-actions>
    <div class="btn-container">
      <button *ngFor="let control of data.ControlArray; let i = index" class="btn" [class.btn-primary]="control.Action === 'YES'"
        [class.btn-secondary]="control.Action !== 'YES'"  md-raised-button (click)="onClose(control.Action)">
        {{ control.Text }}
      </button>
    </div>
  </mat-dialog-actions>
</div>